import React, { useContext, useState } from 'react';


import { AuthContext } from '../../../context/auth';
import Header from '../../../components/Header';
import Barra from '../../../components/barra';
import MenuInmueblesUrbanos from '../../../components/hacienda/inmueblesUrbanos/menuInmueblesUrbanos';
import TablaInmueble from '../../../components/hacienda/inmueblesUrbanos/tablaInmuebles';
import imagen from '../../../imagenes/inmuebles.png';
import { ModalVincular } from '../../../components/hacienda/inmueblesUrbanos/modalVinculoInmueble';
import Footer from '../../../components/Footer';


function VincularInmueble() {

    let op = require('../../../../src/modulos/datos');
    const { user } = useContext(AuthContext);
    let per = JSON.parse(localStorage.getItem('permisos'));


    const [mostrarModal, setMostrarModal] = useState(false);

    const cerrarModal = () => {

        setMostrarModal(false);
    }
    const abrirModal = () => {

        setMostrarModal(true);
    }





    return (



        user && (
            <div style={{ height: "100vh", padding: 0 }}>
                <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
                    <Header />
                </div>

                <div className="row col-md-12" style={{ height: "85%", padding: 0, margin: 0 }}>


                    <div className="col-md-12" style={{ height: "100%", padding: 0 }}>
                        <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
                     
                            <MenuInmueblesUrbanos permisos={per} />
                        </div>

                        <ModalVincular show={mostrarModal} onHideCancelar={cerrarModal} />


                        <div className="row col-md-12" style={{ height: "90%", padding: 0 }}>

                            <div className='col-md-6' style={{ margin: 0, padding: "2%" }}>
                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-3' style={{ color: "#000" }}>
                                        <label>Uso del Inmueble</label>
                                    </div>
                                    <div className='col-md-4' style={{ color: "#000" }}>
                                        <label>Codigo</label>
                                    </div>
                                    <div className="col-md-5" style={{ color: "#000" }}>
                                        <label>Valor de la Construccion</label>
                                    </div>


                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-4'>
                                        <label style={{ color: "#000" }}>Unifamiliar</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal}/* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-4'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-4'>
                                        <label style={{ color: "#000" }}>Bifamiliar</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal} /* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-4'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-4'>
                                        <label style={{ color: "#000" }}>Multifamiliar</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal} /* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-4'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-4'>
                                        <label style={{ color: "#000" }}>Familiar-Comercial</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal} /* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-4'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-4'>
                                        <label style={{ color: "#000" }}>Comercial al Detal</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal} /* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-4'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-4'>
                                        <label style={{ color: "#000" }}>Comercial al Mayor</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal} /* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-4'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-4'>
                                        <label style={{ color: "#000" }}>Mercado Libre</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal} /* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-4'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-4'>
                                        <label style={{ color: "#000" }}>Oficinas</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal} /* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-4'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-4'>
                                        <label style={{ color: "#000" }}>Industrias</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal} /* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-4'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>



                            </div>

                            <div className='col-md-6' style={{ margin: 0, padding: "2%" }}>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-3'>
                                        <label style={{ color: "#000" }}>Uso Terreno</label>
                                    </div>
                                    <div className='col-md-4'>
                                        <label style={{ color: "#000" }}>Codigo</label>
                                    </div>
                                    <div className="col-md-5" style={{ marginTop: 'auto' }}>
                                        <label style={{ color: "#000" }}>Valor de la Construccion</label>
                                    </div>


                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-3'>
                                        <label style={{ color: "#000" }}>Servicios</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal} /* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-5'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-3'>
                                        <label style={{ color: "#000" }}>Agroṕecuario</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal} /* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-5'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-3'>
                                        <label style={{ color: "#000" }}>Institución</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal} /* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-5'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-3'>
                                        <label style={{ color: "#000" }}>Escuela</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal} /* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-5'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-3'>
                                        <label style={{ color: "#000" }}>Banco</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal} /* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-5'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-3'>
                                        <label style={{ color: "#000" }}>Hotel</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal} /* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-5'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>

                                <div className="form-row col-md-12" style={{ marginBottom: "10px" }}>
                                    <div className='col-md-3'>
                                        <label style={{ color: "#000" }}> Motel</label>
                                    </div>
                                    <div className='col-md-2'>
                                        <input className='form-control form-control-sm' />
                                    </div>
                                    <div className="col-md-2" style={{ marginTop: 'auto' }}>
                                        <button style={{ textAlign: "center", color: "white", height: '30px' }} onClick={abrirModal} /* disabled={deshabilitado}  onClick={catalogoOrg}*/ className="btn btn-sm btn-info"><i /* disabled={deshabilitado} */ className="fas fa-search"> Buscar</i> </button>
                                    </div>
                                    <div className='col-md-5'>
                                        <input className='form-control form-control-sm' />
                                    </div>

                                </div>
                                <div className='form-row col-md-12 justify-content-end' style={{ marginTop: "10%" }}>
                                    <div className='col-md-6 justify-content-center'>
                                        <button className="btn btn-primary" style={{ margin: '2%' }}><i className='fas'>  Aceptar</i></button>
                                        <button className="btn btn-danger" style={{ margin: '2%' }}><i className="fas fa-window-close"> Cancelar</i></button>
                                    </div>


                                </div>



                            </div>


                        </div>
                    </div>
                </div>
                <div className="col-md-12" style={{ height: "5%", padding: 0 }}>
                    <Footer />
                </div>

            </div>

        )


    );
}


export default VincularInmueble;
